import { render, staticRenderFns } from "./ReviewsTableOld.vue?vue&type=template&id=c786fce0"
import script from "./ReviewsTableOld.vue?vue&type=script&lang=js"
export * from "./ReviewsTableOld.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTableOld.vue?vue&type=style&index=0&id=c786fce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports